import React from "react";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";

export default class EnviarAcessosEmMassa extends React.Component {
  constructor() {
    super();
    this.state = {};
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e){
    e.preventDefault();
    console.log(e);
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <h3>Enviar Acessos em Massa</h3>
        <form onSubmit={this.handleSubmit}>
          <Form formData={this.state} colCount={1} labelLocation={"top"}>
            <SimpleItem dataField={"acessos"}>
              <Label text={"Enviar acessos separados por vírgula( , )"} />
            </SimpleItem>
          </Form>
          <br />
          <div className={"dx-field"} style={{display: "flex", justifyContent: "center"}}>
            <Button
              type={"success"}
              text={"Enviar"}
              useSubmitBehavior={true}
              width={"18%"}
            />
          </div>
        </form>
      </div>
    );
  }
}
